import { debounce } from "lodash";

const NUM_PATTERN = /\d+(\.\d+)?/;

function toNum(value) {
    NUM_PATTERN.lastIndex = -1;
    const m = NUM_PATTERN.exec(value);
    if (!m) {
        return 0;
    }
    return parseFloat(m[0]);
}

const minWidth = 329.0625;

const minHeight = 585;

function createUnitValue(value, unit = "px") {
    return {
        value,
        unit: unit || "px"
    }
}




const sizeRatio = minWidth / minHeight;
export class InlineBookerController {

    displayed = false;

    element = null;

    hostElement = null;

    previousFrameSize = null;

    /**
     *
     */
    constructor(element, host) {
        this.element = element;
        this.hostElement = host;
    }

    initialize() {
            
    }

    getAppropriateSize() {
        try {
            const wideScreen = window.parent.document.body.clientWidth > 800;
            if (wideScreen) {
                const w = 500;
                return [
                    createUnitValue(500, "px"),
                    createUnitValue(730, "px")
                ];
            }
            
            return [
                createUnitValue(100, "%"),
                createUnitValue(minHeight, "px"),
            ]
        } catch (ex) {
            var isMobile = (/android|ios|iphone|ipod|blackberry|phone/i).test(navigator.userAgent) || (/android|ios|iphone|ipod|blackberry|phone/i).test(navigator.platform);
            var isTablet = (/ipad|tablet/i).test(navigator.userAgent) || (/ipad|tablet/i).test(navigator.platform);

            if (isTablet) {
                return [
                    createUnitValue(500, "px"),
                    createUnitValue(730, "px")
                ];
            }
            if (isMobile) {
                 return [
                    createUnitValue(100, "%"),
                    createUnitValue(minHeight, "px"),
                ]
            }

            return [
                createUnitValue(500, "px"),
                createUnitValue(730, "px")
            ];
            
        }
        
    }

    connect() {
        this.setupImpl();
        // if (window.frameElement) {
        //     this.setupImpl();            
        // } else {
        //     this.displayed = true;
        //     this.respondToDisplayFlag();
        // }
        
    }

    setupImpl() {
        window.addEventListener("message", this.handleWindowMessage);
        
        if (this.element) {
            this.element.querySelectorAll(".open-trigger-button").forEach((el) => {
                el.addEventListener("click", this.handleTrigger);
            });

            this.element.querySelectorAll(".close-trigger-button").forEach((el) => {
                el.addEventListener("click", (evt) => {
                    evt.preventDefault();
                    if (this.displayed) {
                        this.displayed = false;
                        this.respondToDisplayFlag();
                    }
                });
            });
        } else {
            
            setTimeout(() => {
                this.displayed = true;
                this.respondToDisplayFlag();
            }, 1000);
            
        }

        window.addEventListener("movebooker:close_widget", this.hideBooker);

        try {
            if (window.frameElement) {
                window.top.addEventListener("resize", () => {
                    this.handleResize();
                });    
            }
            
        } catch (error) {
            console.error(error);
        }
    }




    handleResize = debounce(() => {
        if (this.displayed) {
            if (window.frameElement) {
                this.applyResize(window.frameElement);
            } else {
                this.reportSizeViaWindowMessage();
            }
        }
    }, 300);

    disconnect() {
        window.removeEventListener("message", this.handleWindowMessage);
        window.removeEventListener("movebooker:close_widget", this.hideBooker);
    }




    handleWindowMessage = (event) => {
        if ("RB_MOVEBOOKER_BOOKING_MESSAGES_CLOSE" === event.data) {
            if (this.displayed) {
                this.displayed = false;
                this.respondToDisplayFlag();
            }            
        }
    };

    hideBooker = () => {
        if (!this.displayed) {
            return;
        }
        this.displayed = false;
        this.respondToDisplayFlag();
    }

    applyResize(frameEl) {
     
        const components = ["width", "height"];

        const size = this.getAppropriateSize();

        components.forEach((attr, index) => {
            const current = frameEl.getAttribute(attr);
            const value = toNum(current);
            const minSize = size[index];
            const sameUnt = current && current.indexOf(minSize.unit) > 0;
            if (sameUnt) {
                if (value < minSize.value) {
                    frameEl.setAttribute(attr, `${minSize.value}${minSize.unit}`);
                }
            } else {
                 frameEl.setAttribute(attr, `${minSize.value}${minSize.unit}`);
            }            
        });
    }

    restoreFrameSize(frameEl) {
        // if (this.previousFrameSize) {
        //     const components = ["width", "height"];
        //     components.forEach((c, index) => {
        //         if (this.previousFrameSize[index]) {
        //             frameEl.setAttribute(c, this.previousFrameSize[index]);
        //         } else {
        //             frameEl.removeAttribute(c);
        //         }
        //     })
        // }
    }

    findAppropriateSize() {
         if (this.displayed) {
            const size = this.getAppropriateSize();
            
            return size.map(x => `${x.value}${x.unit}`).join(",")
         }
        return "";
    }


    reportSizeViaWindowMessage() {
        // window.parent.postMessage(`MOVEBOOKER_IFRAME_SIZE:${this.findAppropriateSize()}`, "*");
    }

    respondToDisplayFlag() {
        if (this.displayed) {
            this.hostElement.classList.remove("closed");
            this.hostElement.classList.add("opened");

            if (this.element) {
                this.element.classList.remove("opened");

                this.element.classList.add("closed");
                this.element.classList.add("hidden");

            }

            
            if (window.frameElement) {
                // if (!this.previousFrameSize) {
                //     this.previousFrameSize = [
                //         window.frameElement.getAttribute("width"),
                //         window.frameElement.getAttribute("height")
                //     ];
                // }

                // this.applyResize(window.frameElement);
            } else {
                this.reportSizeViaWindowMessage();
            }

        } else {
            if (this.element) {
                this.element.classList.remove("closed");

                this.element.classList.remove("hidden");

                this.element.classList.remove("opened");
            }

           
            this.hostElement.classList.remove("opened");
            
            this.hostElement.classList.add("closed");

            if (window.frameElement) {
                this.restoreFrameSize(window.frameElement);                
            } else {
                this.reportSizeViaWindowMessage();
            }
        }
    }


    handleTrigger = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.displayed = !this.displayed;
        this.respondToDisplayFlag();
    }
}